import React from 'react';
import AbstractInput from './abstract-input';
import './form.scss';

export default class FormText extends AbstractInput {
  render() {
    const {
      id,
      type,
      styleType,
      label,
      onFocus,
      onBlur,
      autoFocus,
      disabled,
      maxLength,
      inputRef,
      noMargin,
      fixedLabel = false,
      inputMode,
      name,
      placeholder,
      autoComplete,
      required,
      errorStyle,
      style,
    } = this.props;
    const { value, error } = this.state;
    const styleTypeClass = styleType ?? 'compact';

    return (
      <div className={`form__block-${styleTypeClass} ${noMargin ? 'form__block-without-margin' : ''}`}>
        {fixedLabel && (
          <p className="formtext__fixed-label" style={{ background: 'rgb(250,250,250)' }}>
            {label}
          </p>
        )}

        <div className={`form__field-${styleTypeClass}`}>
          <input
            id={id}
            className={`form__input-compact form__input-compact-test${
              !this.isEmpty(value) ? (error && error.length > 0 ? ` ` : ` form__input-${styleTypeClass}-success`) : ''
            }`}
            type={type}
            value={value}
            placeholder={placeholder}
            onFocus={() => {
              if (onFocus) onFocus();
              this.focus();
            }}
            onBlur={() => {
              if (onBlur) onBlur();
              this.blur();
            }}
            onChange={this.update}
            autoFocus={autoFocus}
            disabled={disabled}
            maxLength={maxLength}
            ref={inputRef}
            style={style}
            inputMode={inputMode}
            name={name}
            autoComplete={autoComplete}
            required={required}
          />

          {!fixedLabel && (
            <label htmlFor={id} className={`form__label-${styleTypeClass}`}>
              {label}
            </label>
          )}
        </div>
        {error && error.length > 0 && (
          <span className={`form__block-${styleTypeClass}-error`} style={errorStyle}>
            {error}
          </span>
        )}
      </div>
    );
  }
}
